import { useMemo } from 'react'
import {
  useHasReceptor,
  useReceptor,
} from 'src/pages/Receptors/receptors.hooks'

export type WorkflowCredentials = {
  Instance?: string
  Site?: string
  Label?: string
  projectId?: string
  site?: string // if the backend sometimes returns lowercase
  label?: string
  [k: string]: unknown
}

export const useGetWorkflowCredentials = (
  receptorModelId: string,
): {
  wfCredentials: WorkflowCredentials
} => {
  const { data: HasReceptor } = useHasReceptor(receptorModelId, true)
  const hasWorkflowReceptor = useMemo(
    () => HasReceptor?.getHasReceptor() || false,
    [HasReceptor],
  )

  const { data: receptor } = useReceptor({
    modelId: receptorModelId,
    shouldFetch: hasWorkflowReceptor,
  })

  const wfCredentials = useMemo<WorkflowCredentials>(() => {
    try {
      const raw = receptor?.getCredentials?.()
      if (!raw) return {}
      return JSON.parse(raw) as WorkflowCredentials
    } catch {
      // bad/malformed JSON → treat as empty
      return {}
    }
  }, [receptor])

  return { wfCredentials }
}
